// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/folder-search.js';

import { paths } from '../generated/folder-search';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('folder-search', Original, paths);
